import { motion, AnimatePresence } from 'framer-motion'

export default function WhatsAppFloat({ chatAbierto }) {
  return (
    <AnimatePresence>
      {!chatAbierto && (
        <motion.a
          href="https://wa.me/5492236355926?text=Hola%2C+vi+tu+p%C3%A1gina+y+quiero+saber+m%C3%A1s+sobre+IDM+Medicina..."
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Contactar por WhatsApp"
          style={{
            position: 'fixed',
            bottom: 20,
            right: 96,
            zIndex: 40,
            width: 56,
            height: 56,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#25D366',
            boxShadow: '0 8px 32px rgba(37,211,102,0.3)',
            textDecoration: 'none',
          }}
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0, opacity: 0 }}
          transition={{
            delay: 1.5,
            type: 'spring',
            stiffness: 200,
            damping: 18,
          }}
          whileHover={{
            scale: 1.12,
            boxShadow: '0 12px 40px rgba(37,211,102,0.45)',
          }}
          whileTap={{ scale: 0.95 }}
        >
          <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13 2C7.477 2 3 6.477 3 12c0 1.89.523 3.66 1.438 5.174L3 23l6.02-1.41A10.003 10.003 0 0013 22c5.523 0 10-4.477 10-10S18.523 2 13 2zm-3.5 7.5c.18 0 .373.004.535.01.18.007.37.02.55.408.215.456.685 1.67.745 1.79.06.12.1.26.02.42-.08.16-.12.26-.24.4-.12.14-.252.31-.36.42-.12.11-.244.23-.105.45.14.22.62.935 1.33 1.515.915.775 1.685 1.015 1.925 1.135.24.12.38.1.52-.06.14-.16.6-.7.76-.94.16-.24.32-.2.54-.12.22.08 1.4.66 1.64.78.24.12.4.18.46.28.06.1.06.58-.14 1.14-.2.56-.94.9-1.3.96-.36.06-.68.08-1.06-.02s-1.22-.46-2.14-1.07c-1.08-.71-1.82-1.63-2.04-1.91-.22-.28-.46-.88-.46-1.5 0-.62.32-1.02.46-1.16.14-.14.3-.18.4-.18z"
              fill="white"
            />
          </svg>
        </motion.a>
      )}
    </AnimatePresence>
  )
}